/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  TextField
} from "@mui/material";
import Select from "react-select";
import { DeleteSharp } from "@mui/icons-material";
import moment from "moment";
import { PollSelect } from "src/utils/common";
import ScheduleEntryList from "../Notification/ScheduleEntryList";

function PollForm({
  getdata,
  setgetdata,
  answer,
  setanswer,
  editingPoll,
  showValidation,
  setShowValidation,
  isLoading,
  loginUser,
  onSubmit,
  onCancel,
  scheduleReadOnly,
  onScheduleEntryRemove
}) {
  const [option, setOption] = useState([]);

  const getOptionsValueList = async (type = 0) => {
    let optiondata = [];
    if (type != 0) {
      const resp = await PollSelect(type, loginUser?.u_type, loginUser?.city_id);
      resp?.map((e) => optiondata.push({ value: e.value, label: e.name }));
      setOption(optiondata);
    }
  };

  useEffect(() => {
    if (getdata.p_type != 0) {
      getOptionsValueList(getdata.p_type);
    }
  }, [getdata.p_type]);

  const onChangeFunction = (e) => {
    if (e.target.name == "p_type") {
      setOption([]);
      setgetdata({ ...getdata, [e.target.name]: e.target.value, p_type_id: "0" });
    } else {
      setgetdata({ ...getdata, [e.target.name]: e.target.value });
    }
  };

  const addanswer = () => {
    setanswer([...answer, { value: "" }]);
  };

  const handleValueChange = (index, newValue) => {
    const updatedAnswer = [...answer];
    updatedAnswer[index].value = newValue;
    setanswer(updatedAnswer);
  };

  const deleteObject = (index) => {
    setanswer(answer.filter((_, i) => index != i));
  };

  return (
    <>
      <Grid container spacing={2}>
        {loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.management_p != 0) ? (
          ""
        ) : (
          <Grid item xs={12}>
            <Stack>
              <FormControl component="fieldset">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        name="show_on_home"
                        checked={getdata.show_on_home == 0 ? false : true}
                        onChange={(e) => {
                          let x = 0;
                          if (e.target.checked == true) x = 1;
                          setgetdata({ ...getdata, [e.target.name]: x });
                        }}
                        value="0"
                      />
                    }
                    label="Show On Home Screen"
                  />
                </FormGroup>
              </FormControl>
            </Stack>
          </Grid>
        )}

        <Grid item xs={12}>
          <Stack spacing={3} style={{ marginBottom: "15px" }}>
            <FormLabel style={{ marginBottom: "0px" }}>Poll Display</FormLabel>
            <RadioGroup
              row
              value={getdata.p_type}
              onChange={onChangeFunction}
              name="p_type"
            >
              {loginUser?.u_type == 0 && (
                <>
                  <FormControlLabel value="0" control={<Radio />} label="LVB" />
                  <FormControlLabel value="1" control={<Radio />} label="State" />
                </>
              )}
              <FormControlLabel value="2" control={<Radio />} label="City" />
              <FormControlLabel value="3" control={<Radio />} label="Chapter" />
            </RadioGroup>
          </Stack>
        </Grid>

        {getdata.p_type != 0 && (
          <Grid item xs={12}>
            <Stack spacing={10} style={{ marginBottom: "15px" }}>
              <label style={{ marginBottom: "10px" }}>
                Select
                {getdata.p_type == 1 ? " State" : getdata.p_type == 2 ? " City" : getdata.p_type == 3 ? " Chapter" : " LVB"}
              </label>
              <Select
                isMulti
                value={
                  option?.filter((opt) => {
                    const raw = (getdata.p_type_id || "0").toString().replace(/^\[|]$/g, "");
                    const ids = raw.split(",").filter(Boolean);
                    return ids.includes(String(opt.value));
                  }) || []
                }
                onChange={(selected) => {
                  const val = selected ? selected.map((s) => s.value).join(",") : "0";
                  setgetdata({ ...getdata, p_type_id: val });
                }}
                menuPortalTarget={document.body}
                options={option}
                placeholder="Select..."
              />
            </Stack>
          </Grid>
        )}

        <Grid item xs={12}>
          <Stack spacing={3} style={{ marginBottom: "15px" }}>
            <TextField
              required
              fullWidth
              autoComplete="off"
              type="text"
              label="Question"
              name="question"
              onChange={onChangeFunction}
              value={getdata?.question ? getdata?.question : ""}
              error={showValidation && getdata.question == "" ? true : false}
              helperText={showValidation && getdata.question == "" ? "Please Enter Poll Question" : ""}
            />
          </Stack>
        </Grid>

        <Grid item xs={12}>
          {answer?.map((ans, i) => (
            <Stack key={i} spacing={3} style={{ marginBottom: "15px" }}>
              <Grid container spacing={2}>
                <Grid item xs={11} style={{ paddingLeft: "0px" }}>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Answer"
                    onChange={(e) => handleValueChange(i, e.target.value)}
                    value={ans.value}
                    error={ans?.value == null}
                    helperText={ans.value == null ? "Please Enter Poll Answer" : ""}
                  />
                </Grid>
                <Grid item xs={1} className="d-flex align-item-center">
                  <IconButton color="error" aria-label="delete" onClick={() => deleteObject(i)}>
                    <DeleteSharp />
                  </IconButton>
                </Grid>
              </Grid>
            </Stack>
          ))}
          <Button onClick={addanswer} style={{ marginTop: "15px" }} variant="contained">
            Add Answer
          </Button>
        </Grid>

        {/* Schedule Entries */}
        <Grid item xs={12}>
          <ScheduleEntryList
            entries={getdata.schedule_entries || []}
            setEntries={(entries) => setgetdata({ ...getdata, schedule_entries: entries })}
            isEditMode={!!editingPoll}
            readOnly={scheduleReadOnly}
            onEntryRemove={onScheduleEntryRemove}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
        <Button
          onClick={onSubmit}
          variant="contained"
          disabled={isLoading}
          startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
        >
          {editingPoll ? "Update Poll" : "Add Poll"}
        </Button>
        {editingPoll && (
          <Button onClick={onCancel} variant="outlined" color="error">
            Cancel Edit
          </Button>
        )}
      </Box>
    </>
  );
}

export default PollForm;
